import { Cost, Demographics } from 'entities';

import { demographicsRenderer } from 'pages/Projects/components';

const verifyCostsFilling = (costs: Record<string, Cost[]>): boolean => {
  const hasNotFilled = Object.values(costs).some((cost) =>
    cost.some(({ type, value, currency }) => !value || (type === currency && !currency)),
  );

  return hasNotFilled;
};

const verifyDemographicsFilling = (demographics: Demographics): boolean => {
  const hasNotFilled =
    demographicsRenderer.some(({ key }) => !demographics[key]) ||
    (demographics.quota && !demographics.quotaDetails);

  return hasNotFilled;
};

export const verifyFilling = (
  costs: Record<string, Cost[]>,
  demographics: Demographics,
): boolean => {
  const costsHasNotFilled = verifyCostsFilling(costs);
  const demographicsHasNotFilled = verifyDemographicsFilling(demographics);

  return costsHasNotFilled || demographicsHasNotFilled;
};
